import type { ReactNode } from 'react';

export const symbol_published_with_changes: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M290-750q-64 51-102 121.5T150-480q0 124 71.5 214.5T402-149q13 3 20.5 13t7.5 23q0 12-9 20t-20 6q-135-27-223-135T90-480q0-88 41.5-168T243-790h-92q-13 0-21.5-8.5T121-820q0-13 8.5-21.5T151-850h169q13 0 21.5 8.5T350-820v169q0 13-8.5 21.5T320-621q-13 0-21.5-8.5T290-651v-99Zm133 356 206-206q9-9 21-9t21 9q9 9 9 21t-9 21L444-331q-9 9-21 9t-21-9L289-444q-9-9-9-21t9-21q9-9 21-9t21 9l92 92Zm294 224h92q13 0 21.5 8.5T839-140q0 13-8.5 21.5T809-110H640q-13 0-21.5-8.5T610-140v-169q0-13 8.5-21.5T640-339q13 0 21.5 8.5T670-309v99q64-52 102-122t38-148q0-124-71.5-214.5T558-811q-13-3-20.5-13t-7.5-23q0-12 9-20t20-6q135 27 223 134.5T870-480q0 88-41.5 168T717-170Z"
		/>
	</svg>
);
